import type { StyleSystemProps } from '@withjoy/joykit';
import { Flex, styled } from '@withjoy/joykit';
import type { ButtonOverrides } from '@withjoy/joykit/components/ButtonV2/Button.types';

export const WrapperStyled = styled(Flex)``;

export const registryGhostButtonStyles: ButtonOverrides = {
  Root: {
    props: {
      color: 'mono14',
      _hover: {
        color: 'mono11',
      },
    },
  },
};

const wrapperStyles: StyleSystemProps = {
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  paddingX: 8,
  paddingTop: 3,
  paddingBottom: 6,
  marginTop: 4,
};

export const styles = {
  registryGhostButton: registryGhostButtonStyles,
  wrapper: wrapperStyles,
};
